export const BOTTOM_SHEET_PADDING_TOP = 24;
export const MOBILE_PROGRESS_FOOTER_HEIGHT = 74;
export const PUBLIC_SERVICES_REQUEST_HEADER_HEIGHT_MOBILE = 64;
export const SERVICES_REQUEST_CONTENT_MAX_WIDTH = 536;
